import { render } from "./Paket.vue?vue&type=template&id=05b1eae7"
import script from "./Paket.vue?vue&type=script&lang=js"
export * from "./Paket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__